<template>
  <div class="credit-bulk-recategorisation">
    <div
      class="credit-bulk-recategorisation__popup i-radius-xl d-flex i-p-md justify-content-between align-items-center"
    >
      <button
        class="credit-bulk-recategorisation__summary-button i-py-xs i-px-3 i-radius-sm i-text-body-3 d-flex i-gap-2 align-items-center"
        @click="onCategoriesUpdated"
      >
        <span>{{ mapSelectedTransactions.length }} items selected</span>
        <i-icon
          symbol="small_delete_1"
          :size="16"
          :colour="palette['light-neutral-10']"
        />
      </button>

      <div class="credit-bulk-recategorisation__divider" />

      <credit-transaction-recategorisation-menu
        :transaction-category="'EMPTY'"
        :transaction-ids="mapSelectedTransactions"
        :bulk-recategorisation="true"
        :bulk-recategorisation-menu-open-state="openState"
        @menu-toggle="handleMenuTrigger"
        @categories-updated="onCategoriesUpdated"
      />
    </div>
    <div
      v-if="openState"
      class="credit-bulk-recategorisation__backdrop"
      @click="handleMenuTrigger(false)"
    />
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';
import CreditTransactionRecategorisationMenu from '@/V2/credit/components/CreditTransactionRecategorisationMenu';

export default {
  components: {
    iIcon,
    CreditTransactionRecategorisationMenu,
  },
  props: {
    selectedTransactions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      palette,
      openState: false,
    };
  },
  computed: {
    mapSelectedTransactions() {
      return this.selectedTransactions.map((transaction) => transaction.id);
    },
  },
  methods: {
    onCategoriesUpdated() {
      this.$emit('categories-updated');
    },
    handleMenuTrigger(openState) {
      this.openState = openState;
    },
  },
};
</script>

<style lang="scss" scoped>
.credit-bulk-recategorisation {
  &__popup {
    z-index: 1;
    background-color: $light-neutral-120;
    overflow: visible;
    width: 500px;
    position: fixed;
    bottom: 20px;
    left: 50%;
    left: calc(50% + 120px);
    transform: translateX(-50%);
  }

  &__divider {
    width: 1px;
    height: 20px;
    border-left: 1px solid $light-neutral-90;
  }

  &__summary-button {
    background-color: $dark-neutral-70;
    border: 0;
    color: $light-neutral-10;

    &:active,
    &:hover {
      background-color: $dark-neutral-60;
    }
  }

  &__backdrop {
    z-index: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
